import { BankingDepositsData } from "@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type";
import { useEffect, useRef, useState } from "react";
import { useWindowSize } from "react-use";
import ReactConfetti from "react-confetti";

interface ConfettiOnPaymentProps {
  bankingDeposit: BankingDepositsData;
}

const ConfettiOnPayment = ({ bankingDeposit }: ConfettiOnPaymentProps) => {
  const leftConfettiRef = useRef(null);
  const rightConfettiRef = useRef(null);

  const { width, height } = useWindowSize();

  const [initialStatus, setInitialStatus] = useState<BankingDepositsData['status']>(bankingDeposit.status);
  const [activeConfetti, setActiveConfetti] = useState(false);

  useEffect(() => {
    if (initialStatus === "pending" && bankingDeposit.status === "paid") {
      setInitialStatus(bankingDeposit.status);
      setActiveConfetti(true);
    }
  }, [bankingDeposit?.status]);

  useEffect(() => {
    if (activeConfetti) {
      setTimeout(() => setActiveConfetti(false), 1800);
    }
  }, [activeConfetti]);

  return (
    <>
      <ReactConfetti
        ref={leftConfettiRef}
        confettiSource={{
          x: 0,
          y: height,
          w: 90,
          h: height * 2,
        }}
        initialVelocityY={22}
        initialVelocityX={14}
        numberOfPieces={activeConfetti ? 6000 : 0}
        recycle={activeConfetti}
        data-testid="confetti_1"
      />

      <ReactConfetti
        ref={rightConfettiRef}
        confettiSource={{
          x: width,
          y: height,
          w: 90,
          h: height * 2,
        }}
        initialVelocityY={22}
        initialVelocityX={14}
        numberOfPieces={activeConfetti ? 6000 : 0}
        recycle={activeConfetti}
        data-testid="confetti_2"
      />
    </>
  );
}

export default ConfettiOnPayment;
